module.exports = __webpack_public_path__ + "img/20.a3e63d92.jpg";